/* Need to eslint no-undef otherwise eslint does not see ApplePayJS global type; TS can see that type */

/* eslint-disable no-undef */
import { actionTypes } from 'actions/actionTypes'
import statusActions from 'actions/status'
import { trackCheckoutError } from 'actions/tracking'
import {
  saveApplePayCheckoutToken,
  saveApplePayDeliveryAddress,
  saveApplePayPersonalInfo,
  validateShippingContact,
  checkoutSignup,
} from 'routes/Checkout/checkoutActions'
import { convertApplePayTokenToCheckoutToken } from 'routes/Checkout/checkoutPaymentsApis'
import { hasCheckoutError } from 'routes/Checkout/checkoutSelectors'
import { CheckoutActionCreator } from 'routes/Checkout/models/ReduxTypes'
import { Pricing } from 'routes/Menu/domains/pricing'

/**
 * Completes checkout payment as if payment was authorized.
 * @param event - Apple Pay payment authorized event
 * @param session - Apple Pay session
 * @param pricing - checkout pricing info (total price, etc.)
 */
export const checkoutApplePayPayment: CheckoutActionCreator =
  (event: ApplePayJS.ApplePayPaymentAuthorizedEvent, session: ApplePaySession, pricing: Pricing) =>
  async (dispatch, getState) => {
    const errors = dispatch(validateShippingContact(event.payment.shippingContact))

    if (errors.length > 0) {
      session.completePayment({
        status: ApplePaySession.STATUS_FAILURE,
        errors,
      })

      return
    }

    dispatch(saveApplePayDeliveryAddress(event.payment.shippingContact))
    dispatch(saveApplePayPersonalInfo(event.payment.shippingContact))

    try {
      const applePayToken = event.payment.token.paymentData
      const { data } = await convertApplePayTokenToCheckoutToken(applePayToken)
      dispatch(saveApplePayCheckoutToken(data.token))
    } catch {
      dispatch(statusActions.error(actionTypes.APPLE_PAY_TOKEN_CONVERSION_ERROR, true))
      dispatch(
        trackCheckoutError(
          actionTypes.APPLE_PAY_TOKEN_CONVERSION_ERROR,
          true,
          'checkoutApplePayPayment',
        ),
      )
      session.completePayment(ApplePaySession.STATUS_FAILURE)

      return
    }

    await dispatch(checkoutSignup({ pricing }))

    const state = getState()
    const isFinishedWithError = hasCheckoutError(state)

    session.completePayment(
      isFinishedWithError ? ApplePaySession.STATUS_FAILURE : ApplePaySession.STATUS_SUCCESS,
    )
  }
